<template>
  <div>
    <v-dialog scrollable v-model="dialog" width="800px" persistent>
      <v-card>
        <v-card-title
          class="lighten-4 py-4 title black--text"
          style="margin-left: 29px; margin-top: 20px; font-weight: 400"
          >Create New Organization</v-card-title
        >
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12 align-center justify-center text-center>
                  <UploadAvatar
                    accept="image/x-png"
                    v-model="Form.banner"
                    :selectedCallback="uploadAvatar"
                  ></UploadAvatar>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="Name"
                    placeholder="Name of organization"
                    v-validate="'required'"
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                    v-model="Form.name"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Description"
                    auto-grow
                    v-validate="'required'"
                    placeholder="Description about first deal"
                    :error-messages="errors.collect('description')"
                    data-vv-name="description"
                    v-model="Form.description"
                    clearable
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Address"
                    auto-grow
                    v-validate="''"
                    placeholder="Full Address of company headquarters"
                    :error-messages="errors.collect('address')"
                    data-vv-name="address"
                    v-model="Form.address"
                    clearable
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :color="Form.color"
                    type="text"
                    label="Color"
                    placeholder="#000000"
                    return-masked-value
                    v-validate="'required|length:7'"
                    :error-messages="errors.collect('color')"
                    data-vv-name="color"
                    v-model="Form.color"
                    clearable
                  >
                    <v-icon :color="Form.color" slot="append-outer">lens</v-icon>
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="Form.parent_organization_id"
                    v-validate="''"
                    :error-messages="errors.collect('parentOranizations')"
                    data-vv-name="parentOranizations"
                    :items="parentOranizations"
                    attach
                    label="Parent Organization"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-subheader style="padding-left: 0px">Category</v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Title 1"
                    type="text"
                    v-validate="''"
                    placeholder="Attribute 1"
                    :error-messages="errors.collect('title1')"
                    data-vv-name="title1"
                    v-model="Form.category1_title"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Title 2"
                    type="text"
                    v-validate="''"
                    placeholder="Attribute 2"
                    :error-messages="errors.collect('title2')"
                    data-vv-name="title2"
                    v-model="Form.category2_title"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Title 3"
                    type="text"
                    v-validate="''"
                    placeholder="Attribute 3"
                    :error-messages="errors.collect('title3')"
                    data-vv-name="title3"
                    v-model="Form.category3_title"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Title 4"
                    type="text"
                    v-validate="''"
                    placeholder="Attribute 4"
                    :error-messages="errors.collect('title4')"
                    data-vv-name="title4"
                    v-model="Form.category4_title"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-subheader style="padding-left: 0px">Sale Representative Admin (optional)</v-subheader>
                </v-flex>
                <v-autocomplete
                  clearable
                  placeholder="Select Admin"
                  item-text="email"
                  item-value="id"
                  v-model="Form.sale_responsible_admin_id"
                  :items="adminList"
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <div class="d-flex align-center">
                      <span>{{ item.email }}</span>
                    </div>
                  </template>

                  <template v-slot:item="{ item }">
                    <div class="d-flex flex-column">
                      <div class="font-weight-medium">{{ item.email }}</div>
                      <div class="text--secondary text-caption">{{ item.roles.join(', ') }}</div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pr-5">
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn text @click="dialog = false,resetFormError(null,Form),doneCreation()">Cancel</v-btn> -->
          <v-btn
            color="primary"
            style="width: 94%; margin-left: 21px; margin-bottom: 20px"
            :disabled="!Form.valid"
            @click="confirmToCreate"
            >Save All</v-btn
          >
          <!-- <v-btn color="primary" text :disabled="!Form.valid" @click="packageDialog = true, dialog = false">Create</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="packageDialog" width="800px" persistent>
      <v-card>
        <v-card-title
          class="lighten-4 py-4 title black--text"
          style="margin-left: 29px; margin-top: 20px; font-weight: 400"
          >Create New Package</v-card-title
        >
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="Package Name"
                    placeholder="Package Name"
                    v-validate="'required'"
                    :error-messages="errors.collect('package')"
                    data-vv-name="package"
                    v-model="Form.package"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="Form.package_type"
                    v-validate="''"
                    placeholder="Package Type"
                    :error-messages="errors.collect('package_type')"
                    data-vv-name="package_type"
                    :items="package_type"
                    attach
                    label="Package Type"
                    v-on:change="onPackageTypeChange($event)"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="Session Max (no. of sessions)"
                    v-validate="'min_value:0'"
                    :error-messages="errors.collect('max_session')"
                    data-vv-name="max_session"
                    v-model="Form.max_session"
                    placeholder="Session Max (no. of sessions)"
                    :disabled="isUnlimitedType"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="Quota per person (sessions)"
                    v-validate="'numeric'"
                    v-model="Form.quota_per_head"
                    :error-messages="errors.collect('quota_per_head')"
                    data-vv-name="quota_per_head"
                    placeholder="Leave this empty for unlimited usage"
                    hint="1 session = 30 minutes. Enter sessions; backend stores as minutes."
                    persistent-hint
                    clearable
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="Quota Refresh Rate"
                    v-validate="'numeric'"
                    v-model="Form.refresh_quota"
                    :error-messages="errors.collect('refresh_quota')"
                    data-vv-name="refresh_quota"
                    clearable
                  ></v-text-field>
                </v-flex> -->
                <v-flex xs12>
                  <v-select
                    v-model="Form.refresh_quota"
                    v-validate="''"
                    :error-messages="errors.collect('refresh_quota')"
                    data-vv-name="refresh_quota"
                    :items="refresh_quota_options"
                    attach
                    placeholder="Quota Refresh Rate"
                    label="Quota Refresh Rate"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    class="select_types"
                    v-model="Form.tag_ids"
                    v-validate="''"
                    :error-messages="errors.collect('tag_ids')"
                    data-vv-name="tag_ids"
                    :items="tags"
                    chips
                    attach
                    multiple
                    label="Tags"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="text"
                    label="User Cap"
                    v-validate="'numeric|min_value:1'"
                    :error-messages="errors.collect('user_cap')"
                    data-vv-name="user_cap"
                    v-model="Form.user_cap"
                    placeholder="Maximum number of employee accounts"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="Form.package_size"
                    v-validate="'required'"
                    :error-messages="errors.collect('package_size')"
                    data-vv-name="package_size"
                    :items="packageSizes"
                    attach
                    label="Package Size"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="Form.package_tier"
                    v-validate="'required'"
                    :error-messages="errors.collect('package_tier')"
                    data-vv-name="package_tier"
                    :items="packageTiers"
                    attach
                    label="Package Tier (Professional / Deluxe / Premium)"
                    hint="Sets the provider quality tier and affects pricing. Separate from Tags."
                    persistent-hint
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Internal Note"
                    auto-grow
                    rows="2"
                    v-validate="''"
                    placeholder="Optional internal note"
                    :error-messages="errors.collect('internal_note')"
                    data-vv-name="internal_note"
                    v-model="Form.internal_note"
                    clearable
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    ref="actualStartDate"
                    :close-on-content-click="false"
                    v-model="actualStartDate"
                    :nudge-right="40"
                    :return-value.sync="Form.actual_start_at"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="actual_start_at"
                        label="Actual Start"
                        prepend-inner-icon="event"
                        @click="actualStartDate = true"
                        readonly
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="Form.actual_start_at"
                      scrollable
                      @change="$refs.actualStartDate.save(Form.actual_start_at)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-menu
                    ref="actualStartTime"
                    :close-on-content-click="false"
                    v-model="actualStartTime"
                    :nudge-right="40"
                    :return-value.sync="Form.actual_start_at_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="actual_start_at_time"
                        label="Time"
                        prepend-inner-icon="access_time"
                        readonly
                        @click="actualStartTime = true"
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-model="Form.actual_start_at_time"
                      @change="$refs.actualStartTime.save(Form.actual_start_at_time)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    ref="actualEndDate"
                    :close-on-content-click="false"
                    v-model="actualEndDate"
                    :nudge-right="40"
                    :return-value.sync="Form.actual_end_at"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="actual_end_at"
                        label="Actual End"
                        prepend-inner-icon="event"
                        @click="actualEndDate = true"
                        readonly
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="Form.actual_end_at"
                      scrollable
                      @change="$refs.actualEndDate.save(Form.actual_end_at)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-menu
                    ref="actualEndTime"
                    :close-on-content-click="false"
                    v-model="actualEndTime"
                    :nudge-right="40"
                    :return-value.sync="Form.actual_end_at_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="actual_end_at_time"
                        label="Time"
                        prepend-inner-icon="access_time"
                        readonly
                        @click="actualEndTime = true"
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-model="Form.actual_end_at_time"
                      @change="$refs.actualEndTime.save(Form.actual_end_at_time)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    ref="packageStartDate"
                    :close-on-content-click="false"
                    v-model="packageStartDate"
                    :nudge-right="40"
                    :return-value.sync="Form.package_start"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="package_start"
                        label="Package Start"
                        prepend-inner-icon="event"
                        @click="packageStartDate = true"
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="Form.package_start"
                      scrollable
                      @change="$refs.packageStartDate.save(Form.package_start)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-menu
                    ref="packageStartTime"
                    :close-on-content-click="false"
                    v-model="packageStartTime"
                    :nudge-right="40"
                    :return-value.sync="Form.package_start_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="package_start_time"
                        label="Time"
                        prepend-inner-icon="access_time"
                        @click="packageStartTime = true"
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-model="Form.package_start_time"
                      @change="$refs.packageStartTime.save(Form.package_start_time)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    ref="packageExpireDate"
                    :close-on-content-click="false"
                    v-model="packageExpireDate"
                    :nudge-right="40"
                    :return-value.sync="Form.expire"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="expire"
                        label="Expire"
                        prepend-inner-icon="event"
                        @click="packageExpireDate = true"
                        readonly
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="Form.expire"
                      scrollable
                      @change="$refs.packageExpireDate.save(Form.expire)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-menu
                    ref="packageExpireTime"
                    :close-on-content-click="false"
                    v-model="packageExpireTime"
                    :nudge-right="40"
                    :return-value.sync="Form.expire_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        v-model="expire_time"
                        label="Time"
                        prepend-inner-icon="access_time"
                        readonly
                        @click="packageExpireTime = true"
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-model="Form.expire_time"
                      @change="$refs.packageExpireTime.save(Form.expire_time)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" style="width: 94%; margin-left: 21px; margin-bottom: 20px" @click="checkPackage()"
            >Create New Package</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import moment from 'moment';
import corporateService from '../services/corporate';
import dateUtil from '../utils/dateTime';
import dataTimePickerMixin from '../Mixins/dateTimePicker';
import corporateMixin from '../Mixins/corporate';
import corporateTransformer from '../transformers/corporate';
import loader from '../utils/loader';
export default {
  mixins: [formMixin, dataTimePickerMixin, corporateMixin],
  data() {
    const minDate = moment().format('YYYY-MM-DD');
    const minTime = moment().format('HH:mm');
    return {
      dialog: true,
      packageStartDate: false,
      packageStartTime: false,
      packageExpireDate: false,
      packageExpireTime: false,
      actualStartDate: false,
      actualStartTime: false,
      actualEndDate: false,
      actualEndTime: false,
      packageDialog: false,
      isUnlimitedType: false,
      tags: [],
      adminList: [],
      parentOranizations: [],
      packageSizes: [
        { text: 'Small (S)', value: 'S' },
        { text: 'Medium (M)', value: 'M' },
        { text: 'Large (L)', value: 'L' },
        { text: 'Pay Per Use (PPU)', value: 'PPU' },
      ],
      packageTiers: [
        { text: 'Professional Mix', value: 'professional_mix' },
        { text: 'Professional Psychologist', value: 'professional_psychologist' },
        { text: 'Deluxe Mix', value: 'deluxe_mix' },
        { text: 'Deluxe Psychologist', value: 'deluxe_psychologist' },
        { text: 'Premium Mix', value: 'premium_mix' },
        { text: 'Premium Psychologist', value: 'premium_psychologist' },
        { text: 'Not Applicable (PPU)', value: 'not_applicable' },
      ],
      Form: new Forms({
        data: () => ({
          name: '',
          address: '',
          category1_title: '',
          category2_title: '',
          category3_title: '',
          category4_title: '',
          user_cap: 100,
          stress_test_limit: 1,
          color: '#000000',
          description: '',
          expire: minDate,
          expire_time: minTime,
          wallet_time: 0,
          max_wallet_time: 0,
          session: 0,
          max_session: 0,
          package: '',
          package_start: minDate,
          package_start_time: minTime,
          parent_organization_id: null,
          package_type: 'time',
          quota_per_head: null,
          refresh_quota: null,
          tag_ids: [],
          banner: null,
          active: null,
          admin_id: null,
          sale_responsible_admin_id: null,
          package_size: '',
          package_tier: '',
          actual_start_at: minDate,
          actual_start_at_time: minTime,
          actual_end_at: minDate,
          actual_end_at_time: minTime,
          internal_note: '',
        }),
        transformToPayload: corporateTransformer.sendCreate,
      }),
    };
  },
  props: {
    doneCreation: Function,
    corporatesTotal: Number,
  },
  computed: {
    package_start() {
      return dateUtil.formatDate(this.Form.package_start);
    },
    expire() {
      return dateUtil.formatDate(this.Form.expire);
    },
    package_start_time() {
      return this.Form.package_start_time;
    },
    expire_time() {
      return this.Form.expire_time;
    },
    actual_start_at() {
      return dateUtil.formatDate(this.Form.actual_start_at);
    },
    actual_end_at() {
      return dateUtil.formatDate(this.Form.actual_end_at);
    },
    actual_start_at_time() {
      return this.Form.actual_start_at_time;
    },
    actual_end_at_time() {
      return this.Form.actual_end_at_time;
    },
  },
  watch: {
    package_start() {
      if (!moment().isSame(this.Form.package_start, 'day')) {
        this.Form.package_start_time = this.startOfDay;
      } else {
        this.Form.package_start_time = this.minTime;
      }
    },
    expire() {
      if (!moment().isSame(this.Form.expire, 'day')) {
        this.Form.expire_time = this.startOfDay;
      } else {
        this.Form.expire_time = this.minTime;
      }
    },
  },
  methods: {
    onPackageTypeChange(event) {
      if (event === 'unlimited') {
        this.isUnlimitedType = true;
      } else {
        this.isUnlimitedType = false;
      }
    },
    allowedStep: (m) => m % 10 === 0,
    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.packageDialog = true;
          this.dialog = false;
        }
      });
    },
    uploadAvatar(image) {
      this.Form.banner = image.imageFile;
    },
    checkPackage() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Create', 'Are you confirm to create?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.createCorporate();
            });
        }
      });
    },
    createCorporate() {
      let localdata = localStorage.getItem('id_token');
      let user = JSON.parse(localdata).user;
      this.Form.admin_id = user.id;
      this.Form.active = true;
      this.Form.max_wallet_time = this.Form.max_session * 30;
      this.Form.wallet_time = this.Form.max_wallet_time;
      this.Form.session = this.Form.max_session;
      corporateService
        .create(this.Form.payload)
        .then((data) => {
          if (this.Form.banner) {
            const formData = new FormData();
            formData.append('banner', this.Form.banner);
            corporateService
              .uploadBanner(data.data.id, formData)
              .then(() => {
                this.packageDialog = false;
                this.doneCreation(true);
                this.$notify({
                  title: 'Success',
                  text: 'Corporate are created!!',
                  type: 'success',
                });
                this.$emit('success');
                this.backOrGoToProfile(data.data);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.packageDialog = false;
            this.doneCreation(true);
            this.$notify({
              title: 'Success',
              text: 'Corporate are created!!',
              type: 'success',
            });
            this.$emit('success');
            this.backOrGoToProfile(data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    backOrGoToProfile(data) {
      this.$root
        .$confirm('Notification', 'Do you want to go to Profile?', {
          color: 'primary',
          submitText: 'Yes',
          cancelText: 'Back',
        })
        .then((confirm) => {
          if (confirm) {
            window.router.push({
              name: 'corporateProfile',
              params: {
                id: data.id,
              },
            });
          }
        });
    },
  },
  mounted() {
    corporateService.fetchTags().then((result) => {
      result.data.forEach((element) => {
        this.tags.push({
          text: element.name,
          value: element.id,
        });
      });
    });
    corporateService.fetchAdminList().then((result) => {
      this.adminList = result;
    });
    this.parentOranizations = [
      {
        text: 'No Parent Organization',
        value: null,
      },
    ];
    let query = {
      per_page: this.corporatesTotal,
      page: 1,
    };
    corporateService.all(query).then((data) => {
      if (data.data) {
        let items = data.data;
        items.forEach((element) => {
          this.parentOranizations.push({
            text: `${element.name} (Parent ID: ${element.id})`,
            value: element.id,
          });
        });
      }
    });
  },
  components: {
    UploadAvatar: loader.component('UploadAvatar'),
  },
};
</script>
<style>
.v-input.select_types .v-chip.v-size--default {
  height: 27px !important;
  position: relative;
  top: 2px;
}
</style>
